export default __webpack_public_path__ + "static/media/img-0302-brazil-full-face.b79a36dc.png";